import { minutesToTimeParts, timePartsToMinutes, TimeParts } from "shared";

export type Duration = TimeParts;

const ZERO_DURATION: Duration = { hours: 0, minutes: 0, seconds: 0 };

export const parseDurationFormula = (formula: string | null): Duration => {
  if (formula === null) {
    return ZERO_DURATION;
  }

  const totalMinutes = Number(formula);
  if (Number.isNaN(totalMinutes) || totalMinutes < 0) {
    return ZERO_DURATION;
  }

  return minutesToTimeParts(totalMinutes);
};

export const formatDurationFormula = (duration: Duration): string =>
  String(timePartsToMinutes(duration));

export const formatDurationLabel = ({ hours, minutes, seconds }: Duration): string =>
  `${hours}h ${String(minutes).padStart(2, "0")}min ${String(seconds).padStart(2, "0")}s`;
